import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styles from './UltraAllFeatures.module.scss';
import AppPaths from '../../../AppPaths';
import { ReactComponent as IconTracking } from '../../../assets/images/icons/icon_tracking.svg';
import { ReactComponent as IconTarget } from '../../../assets/images/icons/icon_target.svg';
import { ReactComponent as IconVet } from '../../../assets/images/icons/icon_vet_black.svg';
import { ReactComponent as IconCar } from '../../../assets/images/icons/icon_car.svg';
import { ReactComponent as IconBell } from '../../../assets/images/icons/icon_bell.svg';

export default function UltraAllFeatures() {
  const { t } = useTranslation();
  const history = useHistory();

  const features = [
    { icon: <IconTracking />, text: t('ultra_gps_tracking') },
    { icon: <IconTarget />, text: t('ultra_callback_safezones') },
    { icon: <IconBell />, text: t('ultra_escape_alerts') },
    { icon: <IconVet style={{ color: 'black' }} />, text: t('ultra_vet_records') },
    { icon: <IconCar />, text: t('ultra_walks_car_rides') },
  ];

  return (
    <div className={styles.allFeaturesSection}>
      <h2 className={styles.allFeaturesHeading}>{t('ultra_all_features')}</h2>
      <div className={styles.featuresGrid}>
        {features.map((feature, index) => (
          <div key={index} className={styles.featureItem}>
            <div className={styles.featureIcon}>{feature.icon}</div>
            <div className={styles.featureText}>{feature.text}</div>
          </div>
        ))}
      </div>
      <div className={styles.compareButton} onClick={() => history.push(AppPaths.Compare)}>
        {t('ultra_compare_products')}
      </div>
    </div>
  );
}
